var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 25,
    viewBox: "0 0 44 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.834 15C23.3245 17.9601 21.7238 20.6217 19.3478 22.4593C16.9719 24.2969 13.9933 25.177 11.0002 24.9258C8.00704 24.6746 5.21681 23.3105 3.18032 21.1026C1.14382 18.8948 0.00904576 16.0036 5.0004e-06 13C-0.00274197 9.9892 1.12639 7.0874 3.16337 4.8703C5.20035 2.6532 7.99632 1.28283 10.9966 1.03106C13.9968 0.779303 16.9821 1.66455 19.36 3.51118C21.738 5.3578 23.335 8.03085 23.834 11H44V15H40V23H36V15H32V23H28V15H23.834ZM12 21C14.1217 21 16.1566 20.1571 17.6569 18.6568C19.1572 17.1565 20 15.1217 20 13C20 10.8783 19.1572 8.84342 17.6569 7.34313C16.1566 5.84284 14.1217 4.99999 12 4.99999C9.87827 4.99999 7.84344 5.84284 6.34315 7.34313C4.84286 8.84342 4 10.8783 4 13C4 15.1217 4.84286 17.1565 6.34315 18.6568C7.84344 20.1571 9.87827 21 12 21Z",
    fill: "#20E083"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenKey);
export default __webpack_public_path__ + "static/media/green-key.c7afe762ee1584066cb6b7c772e2c4e6.svg";
export { ForwardRef as ReactComponent };